import { createTheme } from "@mui/material/styles";
import createBreakpoints from "@material-ui/core/styles/createBreakpoints";

declare module "@mui/material/styles" {
  interface Palette {
    darkBlue: string;
  }
  interface PaletteOptions {
    darkBlue: string;
  }
}

const DARK_BLUE_COLOR = "#07154E";
const SUCCESS_COLOR = "#56C65B";

const { palette } = createTheme();
const breakpoints = createBreakpoints({});

const theme = createTheme({
  palette: {
    primary: {
      main: "#015FEE",
      contrastText: "#fff",
      light: "#DDEAFD",
    },
    secondary: {
      main: "#FFBA34",
      contrastText: "#fff",
    },
    success: {
      main: SUCCESS_COLOR,
      contrastText: "#fff",
    },
    darkBlue: palette.augmentColor({
      color: {
        main: DARK_BLUE_COLOR,
      },
      name: "darkBlue",
    }),
  },
  MuiCssBaseline: {
    styleOverrides: `
      @import url('https://fonts.googleapis.com/css2?family=Fira+Sans:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap');
    `,
  },
  typography: {
    fontFamily: ["Fira Sans"].join(","),
    fontSize: 16,
  },
  components: {
    MuiTypography: {
      styleOverrides: {
        h1: {
          fontSize: "2rem",
          fontWeight: 500,
          color: DARK_BLUE_COLOR,
        },
        h2: {
          fontSize: "1.75rem",
          fontWeight: 400,
          color: DARK_BLUE_COLOR,
        },
        h3: {
          fontSize: "1.25rem",
          fontWeight: 500,
          color: DARK_BLUE_COLOR,
        },
        h4: {
          fontSize: "1rem",
          color: DARK_BLUE_COLOR,
        },
        h5: {
          fontSize: "0.75rem",
          color: DARK_BLUE_COLOR,
        },
        h6: {
          fontSize: "0.5rem",
          color: DARK_BLUE_COLOR,
        },
        body1: {
          fontSize: "1rem",
          fontWeight: 300,
        },
        caption: {
          fontSize: "0.75rem",
          fontWeight: 400,
        },
      },
    },
    MuiDialogTitle: {
      styleOverrides: {
        root: {
          fontSize: 28,
        },
      },
    },
    MuiButtonBase: {
      styleOverrides: {
        root: {},
      },
    },
    MuiButtonGroup: {
      defaultProps: {
        disableElevation: true,
      },
      styleOverrides: {
        root: {
          borderRadius: 8,
        },
        firstButton: {
          borderColor: "rgba(0,0,0,0.2)",
        },
      },
    },
    MuiButton: {
      defaultProps: {
        disableElevation: true,
        variant: "contained",
      },
      styleOverrides: {
        root: {
          borderRadius: 8,
          fontSize: "1rem",
          textTransform: "none",
          fontWeight: 300,

          variants: [
            {
              props: { variant: "contained", color: "success" },
              style: {
                background: `linear-gradient(${SUCCESS_COLOR}, #4CAF50)`,
                "&:hover": {
                  background: `linear-gradient(${SUCCESS_COLOR},rgb(63, 154, 66))`,
                },
              },
            },
          ],
        },
      },
    },
    MuiSelect: {
      styleOverrides: {
        root: {
          // borderRadius: 8,
          fontSize: "1rem",
        },
      },
    },
    MuiMenuItem: {
      styleOverrides: {
        root: {
          fontSize: "1rem",
        },
      },
    },
    MuiInputBase: {
      styleOverrides: {
        root: {
          backgroundColor: "white",
        },
      },
    },
    //TODO: Change alert to snackbar
    MuiSnackbar: {
      styleOverrides: {
        root: {
          // MuiAlert: {
          //   styleOverrides: {
          //     root: {
          //       color: '#FFFFFF',
          //     }
          //   }
          // }
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        rounded: {
          borderRadius: 8,
        },
      },
    },
    MuiFormHelperText: {
      styleOverrides: {
        root: {
          marginLeft: 0,
        },
      },
    },
    MuiTab: {
      styleOverrides: {
        root: {
          fontSize: "0.85rem",
        },
      },
    },
    MuiDrawer: {
      defaultProps: {
        anchor: "right",
        PaperProps: {
          sx: {
            backgroundColor: "#DDEAFD",
            borderRadius: 0,
            width: "60%",

            [breakpoints.down("sm")]: {
              width: "100%",
            },
          },
        },
      },
    },
  },
});

export default theme;
